// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f7db5bb5","457":"ee5eab6b","851":"0f0cac23"}[chunkId] + ".chunk.js";
};